// The invitation email's default BODY.
//
// The greeting used to be baked into the BE's email template, which made it
// invisible here: an author who wrote their own "Hi Sam," got two greetings, and
// had no way to remove the one they couldn't see. The BE no longer injects it, so
// the greeting now starts life as the first line of the editable body — visible,
// and free to be kept, reworded or deleted like any other line.
//
// `{{first_name}}` is a MERGE TAG the BE substitutes per recipient (falling back
// to "there" when it has no first name for them), so it must survive translation
// byte-for-byte. That's why it's passed into the message as a value rather than
// written inside it: run through ICU, a literal `{{first_name}}` is a parse error,
// and any escaping that fixed it would be one translator away from breaking again.
export const FIRST_NAME_TAG = "{{first_name}}";

// Quill writes an empty line as <p><br></p>; a bare <p></p> is dropped on load,
// which would leave the cursor on the greeting line itself.
const BLANK_LINE = "<p><br></p>";

// `formatMessage` is react-intl's, so the greeting follows the collector's locale
// like the subject/header/button defaults beside it.
export const defaultEmailBody = (formatMessage) =>
    `<p>${formatMessage(
        { id: "collector_configure.body_default_greeting", defaultMessage: "Hello {name}," },
        { name: FIRST_NAME_TAG }
    )}</p>${BLANK_LINE}`;
